"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var ScreenCard_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/card/ScreenCard"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var framework_1 = require("../../../widgets/framework");
var styles_1 = __importDefault(require("../styles"));
var REACTIVATION_TYPES = {
    success: {
        message: 'reactivation.success.message',
        title: 'reactivation.success.title'
    },
    error: {
        message: 'reactivation.error.message',
        title: 'reactivation.error.title'
    }
};
var ReactivationContent = function (_a) {
    var _b;
    var type = _a.type, loading = _a.loading;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var isUpLgMediaQuery = (0, core_1.useMediaQuery)(function () { return theme.breakpoints.up('lg'); });
    var title;
    var displayBox;
    var onNavigateToLogin = function () {
        framework_1.GoFwInternalInstance.onHostLogin();
    };
    if (!loading) {
        var pass = type === 'active' || type === 'success';
        var icon = pass ? 'done' : 'error_outline';
        var content = REACTIVATION_TYPES[type] || REACTIVATION_TYPES['error'];
        title = t(content.title);
        displayBox = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Icon, { className: (0, classnames_1.default)((_b = {},
                    _b[classes.icon] = true,
                    _b[classes.iconSuccess] = pass,
                    _b[classes.iconError] = !pass,
                    _b)) }, icon),
            react_1.default.createElement(core_1.Typography, { variant: "body1", className: classes.gotoText }, t(content.message))));
    }
    else {
        title = t('reactivation.loadingTitle');
        displayBox = (react_1.default.createElement("div", { className: classes.loadingBox },
            react_1.default.createElement(package_1.AppSpinner, { customStyles: {
                    backgroundColor: 'transparent'
                } })));
    }
    return (react_1.default.createElement(ScreenCard_1.default, { title: title },
        react_1.default.createElement(core_1.Grid, { container: true, justify: "center", alignItems: "center", style: { marginBottom: isUpLgMediaQuery ? '0' : theme.spacing(3) } },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 11, sm: 9, lg: 8 },
                react_1.default.createElement("div", { className: classes.box }, displayBox))),
        isUpLgMediaQuery && (react_1.default.createElement(core_1.Typography, { variant: "body1", className: classes.gotoText }, t('reactivation.content.goto'))),
        react_1.default.createElement(core_1.Button, { size: "large", variant: isUpLgMediaQuery ? 'outlined' : 'contained', color: "primary", "aria-label": t('reactivation.content.btn'), onClick: onNavigateToLogin, style: { paddingLeft: '4em', paddingRight: '4em' } }, t('reactivation.content.btn'))));
};
exports.default = ReactivationContent;
//# sourceMappingURL=ReactivationContent.js.map